export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-best_lunch_2025.f967ef7d.png";